import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Container from '../../components/Container';
import Section from '../../components/Section';
import backgroundImage from '../../img/hero-background.svg';
import { AppState } from '../../types/store';
import { fetchVacancy } from './actions';
import HiringManagerVideo from './components/HiringManagerVideo';

interface VacancyProps {
    vacancyId: string;
    vacancyName: string;
    videoReference: string | null;
}

interface VacancyDispatchProps {
    onLoad: (vacancyId: string) => void;
}

/* const NotificationLayout = Box.extend`
    background-color: ${(props) => props.theme.primary};
    color: ${(props) => props.theme.textInverted};
`;

const NotificationText = styled.div`
    flex: 1 1;
`;

const NotificationAction = styled.div`
    flex: 0 1;
`; */

class ViewApplication extends React.Component<VacancyProps & VacancyDispatchProps, any> {
    constructor(props: VacancyProps & VacancyDispatchProps) {
        super(props);
        props.onLoad(props.vacancyId);
    }

    public render() {
        return (
            <div style={{ overflow: 'hidden' }}>
                <Section image={backgroundImage} dark>
                    <Container>
                        <h1>Welcome to V-Sponse</h1>
                        <h3>Your video platform to get connected with top career opportunities.</h3>
                        <p>
                            In V-Sponse you can watch a video message from the hiring manager outlining why you should
                            join the team and take on the challenges of the position.
                        </p>
                        <p style={{ display: 'none' }}>
                            Please also add documents like your cv or certificates. You can do this at the bottom of the
                            page.
                        </p>
                        <p>
                            We hope you enjoy using V-Sponse. If you have questions or suggestions leave us a short
                            notice:{' '}
                            <a style={{ color: 'white' }} href="mailto:contact@r-squared.ch">
                                contact@r-squared.ch
                            </a>
                        </p>
                    </Container>
                </Section>
                <Section>
                    <Container>
                        <h1>{this.props.vacancyName}</h1>
                        <HiringManagerVideo videoReference={this.props.videoReference} />
                    </Container>
                </Section>
            </div>
        );
    }
}

export const mapStateToProps = (state: AppState, ownProps): VacancyProps => {
    return {
        vacancyId: ownProps.match.params.vacancyId,
        vacancyName: state.vacancy.name,
        videoReference: state.vacancy.videoReference,
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>): VacancyDispatchProps => {
    return {
        onLoad: (vacancyId: string) => dispatch(fetchVacancy(vacancyId)),
    };
};

export default connect<VacancyProps, VacancyDispatchProps, void>(mapStateToProps, mapDispatchToProps)(ViewApplication);



// WEBPACK FOOTER //
// ./src/scenes/vacancy/index.tsx